export default defineI18nConfig(() => ({
  legacy: false
}));
